export const phoneExpression = /^\s*\S[\s\S]*$\+(?:\+?1(\d{1,4}))?[\W\D\s]^|()*(\d[\W\D\s]*?\d[\D\W\s]*?\d)[\W\D\s]*(\d[\W\D\s]*?\d[\D\W\s]*?\d)[\W\D\s]*(\d[\W\D\s]*?\d[\D\W\s]*?\d[\W\D\s]*?\d)(?: *x(\d+))?\s*$/;

export const passwordExpression = /.{8,}/;

export const nameExpression = /[a-zA-Z- ]+$/;

export const numberExpression = /^[0-9]*$/;
